const BASE = process.env.REACT_APP_API_URL || 'http://localhost:8080';

function getHeaders() {
  const token = sessionStorage.getItem('accessToken');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

async function request(method, url, body, params) {
  let fullUrl = `${BASE}${url}`;
  if (params && Object.keys(params).length > 0) {
    fullUrl += '?' + new URLSearchParams(params).toString();
  }
  const res = await fetch(fullUrl, {
    method,
    headers: getHeaders(),
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });

  if (!res.ok) {
    let data;
    try { data = await res.json(); } catch {}

    // Auto-redirect on session expiry, but NOT for auth endpoints — those return
    // 401/403 for "wrong password" or "email_not_verified", which the page handles.
    const isAuthEndpoint = url.startsWith('/api/auth/');
    if (!isAuthEndpoint && (res.status === 401 || res.status === 403)) {
      sessionStorage.clear();
      window.location.href = '/';
      throw new Error('Session expired. Please log in again.');
    }

    const message = data?.message || data?.error || res.statusText;
    throw Object.assign(new Error(message), {
      status: res.status,
      response: { status: res.status, data },
    });
  }

  const text = await res.text();
  return { data: text ? JSON.parse(text) : null };
}

const api = {
  get:    (url, { params } = {}) => request('GET',    url, undefined, params),
  post:   (url, body)            => request('POST',   url, body),
  put:    (url, body)            => request('PUT',    url, body),
  patch:  (url, body)            => request('PATCH',  url, body),
  delete: (url)                  => request('DELETE', url),
};

export default api;
